// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shu[data-v-2516f990] {\n  display: flex;\n  flex-direction: column;\n}\n.shu > label[data-v-2516f990] {\n  margin-top: 10px;\n}\n.shu .des[data-v-2516f990] {\n  margin-left: 20px;\n  color: #1890ff;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
